export default {
    methods: {
        fetchVerificationTypes () {
            let self = this;
            return dokan.api.get('/seller-badge/verification-types/')
            .done(async ( response ) => {
                return response;
            })
            .fail( ( jqXHR ) => {
                let message = dokan_handle_ajax_error( jqXHR );
                if ( message ) {
                    self.showErrorAlert( message );
                }
                return {};
            } );
        },

        getBadgeLevelConditionText( event, level, verificationTypes = {} ) {
            let level_data = level.level_data;
            if ( 'price' === event.condition_text.type ) {
                level_data = accounting.formatMoney( level.level_data, dokan.currency );
            }
            else if( 'verified_seller' === event.id ) {
                level_data = undefined !== verificationTypes[ level.level_condition ] ? verificationTypes[ level.level_condition ].title : level_data;
            }
            else if ( 'trending_product' === event.id ) {
                level_data = sprintf( this.__( 'Based on top %d (%s) best selling products.' ), level.level_data, level.level_condition );
            }
            let condition_text = `${event.condition_text.prefix} ${level.formatted_condition} <em>${level_data}</em> ${event.condition_text.suffix}`;
            return this.ucFirst( condition_text );
        },

        isYearActiveEvent( event ) {
            return undefined !== event.event_type && 'years_active' === event.event_type;
        },

        ucFirst( value ) {
            value = value.toLowerCase();
            let uc_first = value[0].toUpperCase()
            return uc_first + value.slice( 1 );
        },

        sleep(milliseconds) {
            return new Promise((resolve) => setTimeout(resolve, milliseconds));
        },

        getSwal() {
            const swal = Swal.mixin({
                customClass: {
                    confirmButton: 'button button-primary',
                    cancelButton: 'button button-secondary'
                },
                buttonsStyling: true
            });
            return swal;
        },

        showAlert( $title, $des, $status ) {
            this.getSwal().fire( $title, $des, $status );
        },

        showErrorAlert( message ) {
            let self = this;
            this.getSwal().fire(
                self.__( 'Something went wrong', 'dokan' ),
                message,
                'error'
            );
        },

        decodeHtml(html) {
            const txt = document.createElement("textarea");
            txt.innerHTML = html;
            return txt.value;
        }
    }
}
